export const ROUTE_LOGIN = 'ROUTE_LOGIN';
export const ROUTE_GAME = 'ROUTE_GAME';
